export default {"src":"/_next/static/media/bookNowcalendar.067021a7.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};